(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  // Starts the video only once the banner is actually on screen (autoplay
  // otherwise ignores scroll position and just runs from page load), and
  // stops it again when it scrolls out. A manual pause from the toggle
  // sticks across scrolling until the visitor presses play again.
  class VideoBanner extends HTMLElement {
    constructor() {
      super();
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.isVisible = false;
    }

    // Reading children/attributes belongs in connectedCallback, not the
    // constructor: the constructor can run before the element's own markup
    // is guaranteed parseable (e.g. on a re-render from the theme editor),
    // which previously left this.video/this.toggle null and made every
    // method below silently do nothing.
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('.banner__video-toggle');

      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.syncPlayback = this.syncPlayback.bind(this);
      this.handleIntersect = this.handleIntersect.bind(this);

      this.toggle.addEventListener('click', this.handleToggleClick);
      this.reducedMotionQuery.addEventListener('change', this.syncPlayback);

      // threshold: 0 fires as soon as any part of the banner is on screen,
      // rather than waiting for 50% visibility - a banner taller than the
      // viewport (banner--large, banner--full) could otherwise never cross
      // a 0.5 threshold and would never autoplay at all.
      this.observer = new IntersectionObserver(this.handleIntersect, { threshold: 0 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.toggle.removeEventListener('click', this.handleToggleClick);
      this.reducedMotionQuery.removeEventListener('change', this.syncPlayback);
      this.observer.disconnect();
    }

    handleIntersect(entries) {
      this.isVisible = entries[0].isIntersecting;
      this.syncPlayback();
    }

    handleToggleClick() {
      this.userPaused = !this.video.paused;
      this.syncPlayback();
    }

    syncPlayback() {
      if (this.isVisible && !this.reducedMotionQuery.matches && !this.userPaused) {
        this.play();
      } else {
        this.pause();
      }
    }

    play() {
      this.video.play();
      this.toggle.setAttribute('aria-label', 'Pause video');
      this.classList.add('banner__media--playing');
    }

    pause() {
      this.video.pause();
      this.toggle.setAttribute('aria-label', 'Play video');
      this.classList.remove('banner__media--playing');
    }
  }

  if (!customElements.get('video-banner')) {
    customElements.define('video-banner', VideoBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('multicolumn-video-item')) {
  customElements.define(
    'multicolumn-video-item',
    class MulticolumnVideoItem extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.multicolumn-card__video-toggle');
        if (!this.video || !this.toggle) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // A manual pause is a deliberate choice - once it happens, scrolling
        // the column back into view should not restart the video for the
        // visitor without them asking for it again.
        this.userPaused = false;

        this.video.addEventListener('play', () => this.setPlayingState(true));
        this.video.addEventListener('pause', () => this.setPlayingState(false));
        this.toggle.addEventListener('click', () => this.onToggleClick());

        this.setPlayingState(false);

        if (!this.reducedMotion) {
          this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
            threshold: 0.5,
          });
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onIntersect(entries) {
        if (this.userPaused) return;
        const entry = entries[0];
        if (entry.isIntersecting) {
          this.video.play().catch(() => {
            // Autoplay can be blocked by the browser (e.g. low power mode);
            // the button still lets the visitor start it manually.
          });
        } else {
          this.video.pause();
        }
      }

      onToggleClick() {
        if (this.video.paused) {
          this.userPaused = false;
          this.video.play().catch(() => {});
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }

      setPlayingState(isPlaying) {
        this.classList.toggle('is-playing', isPlaying);
        this.toggle.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
